import React from 'react';
import {MagicLinkPage} from '../../components/MagicLink';
import {useSendMagicLink} from '../../hooks/magicLink';
import {useViewer} from '../../hooks/auth';
import {Navigate} from 'react-router-dom';
import {route} from '../../constants/routes';

export const MagicLink = () => {
  const viewer = useViewer();
  const {onSend, success, error} = useSendMagicLink();
  if (viewer) return <Navigate to={route.groups.path} />;
  return <MagicLinkPage onSend={onSend} success={success} error={error} />;
};
